import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import { SearchProvider } from './contexts/SearchContext';
import Auth from './components/Auth';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import HistoryPage from './pages/HistoryPage';
import RecentPage from './pages/RecentPage';
import FoldersPage from './pages/FoldersPage';
import ProfilePage from './pages/ProfilePage';
import AdminUsersPage from './pages/AdminUsersPage';
import VideoAnalysisPage from './pages/VideoAnalysisPage';
// TEMPORARILY HIDDEN - AI Agent settings page (see AI_AGENT_FEATURE_NOTE.md)
// import AISettingsPage from './pages/AISettingsPage';
import './App.css';

function App() {
  const { currentUser } = useAuth();

  if (!currentUser) {
    return <Auth />;
  }

  return (
    <Router>
      <SearchProvider>
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/videos" element={<HistoryPage />} />
            <Route path="/video/:videoId" element={<VideoAnalysisPage />} />
            <Route path="/recent" element={<RecentPage />} />
            <Route path="/favourites" element={<FoldersPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/admin/users" element={<AdminUsersPage />} />
            {/* TEMPORARILY HIDDEN - AI Agent settings page (see AI_AGENT_FEATURE_NOTE.md) */}
            {/* <Route path="/ai-settings" element={<AISettingsPage />} /> */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Layout>
      </SearchProvider>
    </Router>
  );
}

export default App;
